import React from 'react';
import useSocket from '../socket/useSocket';
import useUser from '../global/useUser';
import { invalidateAppointments } from '../../services/appointments';
import { invalidateBatchTimeBlocksEmployee } from '../../services/employee';

interface TimeBlocksChangedData {
  employeeId: string;
}

function useCalendarSocket(selectedArtists: string[]) {
  const socket = useSocket();
  const { user } = useUser();

  const selectedArtistsRef = React.useRef(selectedArtists);
  selectedArtistsRef.current = selectedArtists;

  React.useEffect(() => {
    if (!user?.business?.id) return undefined;

    const onAppointmentChanged = () => {
      invalidateAppointments();
    };

    const onTimeBlocksChanged = (data: TimeBlocksChangedData) => {
      if (!data?.employeeId) return;
      invalidateBatchTimeBlocksEmployee({
        employeeId: data.employeeId,
        selectedArtists: selectedArtistsRef.current,
      });
    };

    socket.on('appointmentChanged', onAppointmentChanged);
    socket.on('timeBlocksChanged', onTimeBlocksChanged);

    return () => {
      socket.off('appointmentChanged', onAppointmentChanged);
      socket.off('timeBlocksChanged', onTimeBlocksChanged);
    };
  }, [socket, user?.business?.id]);
}

export default useCalendarSocket;
